// spacing
export const SSectionVerticalMarginClasses = 'mt-8 lg:mt-10'
export const SSectionSeparatorMarginClasses = 'mb-8 lg:mb-10'
export const SSectionverticalPaddingClasses = 'py-12 lg:py-16'

// color
export type SSectionBackgroundColorsProp =
  | 'gray-50'
  | 'transparent'
  | 'primary-700'
  | 'primary-900'

export const SSectionBackgroundColor: SSectionBackgroundColorsProp =
  'transparent'

export const SSectionBackgroundColorsClasses = {
  transparent: '',
  'gray-50': 'bg-gray-50',
  'primary-700': 'bg-primary-700',
  'primary-900': 'bg-primary-900',
}

export const SSectionTextColorsClasses = {
  transparent: '',
  'gray-50': '',
  'primary-700': 'text-white',
  'primary-900': 'text-white',
}
